import React from 'react';
import {isMobile} from 'react-device-detect';
import './App.css';
import {getDesktopRender} from "./Desktop";
import {getMobileRender} from "./Mobile";

function App() {
    return <div style={{fontFamily: 'OwnglyphMeetme'}}>
        {(isMobile ? getMobileRender() : getDesktopRender())}
    </div>
}

export default App;
